export default __webpack_public_path__ + "static/media/Myproject1.78316c7c.png";